export const GET_DOCTORS_REQUEST = "GET_DOCTORS_REQUEST"
export const GET_DOCTORS_SUCCESS = "GET_DOCTORS_SUCCESS"
export const GET_DOCTORS_ERROR = "GET_DOCTORS_ERROR"
export const DOCTORS_RESET_STORE = "DOCTORS_RESET_STORE"
